import { ODataComparer } from './odata-comparer';
import { DateValidatorService } from '../../services/validation/date-validator.service';
import { GuidValidatorService } from '../../services/validation/guid-validator.service';
import { NumberValidatorService } from '../../services/validation/number-validator.service';

export class ODataFilter{

    private static readonly dateValidator:DateValidatorService = new DateValidatorService();
    private static readonly guidValidator:GuidValidatorService = new GuidValidatorService();
    private static readonly numberValidator:NumberValidatorService = new NumberValidatorService();
    private static readonly comparerFunctions:ODataComparer[] = [ODataComparer.StartsWith, ODataComparer.Contains];

    constructor(private property:string, private comparer:ODataComparer, private value:any){
        
    }

    private getComparisonStringFromComparitor(){
        switch(this.comparer){

            case ODataComparer.Equals:
                return "eq";

            case ODataComparer.NotEqual:
                return "ne";

            case ODataComparer.GreaterThan:
                return "gt";

            case ODataComparer.GreaterThanOrEqual:
                return "ge";

            case ODataComparer.LessThan:
                return "lt";

            case ODataComparer.LessThanOrEqual:
                return "le";

            default:
                //TODO: Throw an error if comparer is not of the correct type
                
        }

        return "";
    }

    public toString():string{
        if(this.isComparisonFunction()){
            return this.toComparisonFunctionString();
        }

        return this.toComparisonString();
    }

    private toComparisonString():string{
        let comparisonString = this.getComparisonStringFromComparitor();

        //Guid and numeric values need to be represented without quotes
        if(ODataFilter.guidValidator.isGuid(this.value) || ODataFilter.numberValidator.isNumber(this.value)){
            return `${this.property} ${comparisonString} ${this.value}`;
        }else if(ODataFilter.dateValidator.isDate(this.value)){
            return `${this.property} ${comparisonString} ${this.value.format("yyyy-mm-dd'T'HH:MM:ss'Z'")}`;
        }else{
            //String values need single quotes
            return `${this.property} ${comparisonString} '${this.value}'`;
        }
    }

    private toComparisonFunctionString():string{
        switch(this.comparer){

            case ODataComparer.StartsWith:
                return `startswith(${this.property}, '${this.value}') eq true`;

            case ODataComparer.Contains:
                return `indexof(${this.property}, '${this.value}') ne -1`;

            default:
                //Should not occur
                break;
        }

        return "";
    }

    private isComparisonFunction():boolean{
        return ODataFilter.comparerFunctions.indexOf(this.comparer) != -1;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/utility/odata/odata-filter.ts